import { z } from "zod"

import { SortingOrder, WarehouseShelvingBinSize, WarehouseShelvingSortField } from "@/graphql/codegen/graphql"

// This schema is used for warehouse shelving search params
export const WarehouseShelvingSearchParamsSchema = z.object({
  field: z.nativeEnum(WarehouseShelvingSortField).optional().default(WarehouseShelvingSortField.Name),
  order: z.nativeEnum(SortingOrder).default(SortingOrder.Asc),
  query: z.string().optional().default(""),

  // by Shelving Type
  coldStorage: z.boolean().nullish(),
  h3ColdStorage: z.boolean().nullish(),
  deep: z.boolean().nullish(),

  binSize: z.nativeEnum(WarehouseShelvingBinSize).array().nullish(),

  // Bin Status
  isDoNotUse: z.boolean().nullish(),
  isAvailable: z.boolean().nullish(),

  isUndefined: z.boolean().nullish(),
})

export const WarehouseShelvingSearchParamsSchemaKeys = WarehouseShelvingSearchParamsSchema.keyof()

export type WarehouseShelvingSearchParams = z.infer<typeof WarehouseShelvingSearchParamsSchema>
